<script lang="ts" setup>
defineProps<{
  label: string;
  version?: string;
}>();
</script>

<template>
  <div :class="`load-wrapper ${version ? version : ''}`">
    <div class="loading-content">
      <div class="loader" />
      <small>{{ label }}</small>
    </div>
  </div>
</template>
<style scoped>
.load-wrapper {
  position: relative;
  padding: 10rem 0;
  /* animation: 1s ease-in-out fadeIn; */
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  40% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.loading-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.inline .loading-content {
  position: relative;
  background-color: transparent;
  width: fit-content;
  height: fit-content;
  color: var(--color-slate-400);
}
small {
  margin-top: 1rem;
}
.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite
}
.loader::before , .loader::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  border: 5px solid var(--color-rose-200);
  animation: prixClipFix 2s linear infinite ;
}
.loader::after{
  transform: rotate3d(90, 90, 0, 180deg );
  border-color: var(--color-rose-600);
}

@keyframes rotate {
  0%   {transform: rotate(0deg)}
  100%   {transform: rotate(360deg)}
}

@keyframes prixClipFix {
    0%   {clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}
    50%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}
    75%, 100%  {clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}
}
</style>
